import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import * as authService from '../../utils/authService';

/**
 * A wrapper component that checks for authentication before rendering children
 * Redirects to admin login if not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const authenticated = await authService.isAuthenticated();
        setIsAuth(authenticated);
      } catch (err) {
        console.error("Auth check error:", err);
        setIsAuth(false);
      } finally {
        setAuthChecked(true);
      }
    };

    checkAuth();
  }, []);

  // Redirect to login if not authenticated (only after auth check is complete)
  if (authChecked && !isAuth) {
    return <Navigate to="/admin/login" replace />;
  }

  // Render children immediately - they have their own skeleton loading states
  // This prevents double loading indicators (overlay + skeleton)
  return children;
};

export default ProtectedRoute; 